// extracted by mini-css-extract-plugin
module.exports = {"button":"accordion-module--button--1PMQE","expanded":"accordion-module--expanded--PQqyH"};